import { appEntry } from '@/mocks/homeData';

export default function AppEntry() {
  return (
    <section id="app" className="w-full py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-8 md:gap-12">
          <div className="flex-1 w-full text-center lg:text-left">
            <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-primary-100/80 text-primary-700 text-xs font-medium mb-4">
              <i className="ri-smartphone-line"></i>
              {appEntry.version}
            </span>
            <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">{appEntry.title}</h2>
            <p className="text-sm md:text-base text-foreground-600 mb-4">{appEntry.subtitle}</p>
            <p className="text-sm text-foreground-600 leading-relaxed mb-6 max-w-[560px] lg:max-w-none">
              {appEntry.desc}
            </p>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#features"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#features')?.scrollIntoView({ behavior: 'smooth' });
                }}
                className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-6 py-3 bg-primary-500 text-background-50 font-semibold text-sm rounded-md hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-apple-line text-lg"></i>
                iOS 下载
              </a>
              <a
                href="#features"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#features')?.scrollIntoView({ behavior: 'smooth' });
                }}
                className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-6 py-3 bg-secondary-500 text-background-50 font-semibold text-sm rounded-md hover:bg-secondary-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-android-line text-lg"></i>
                Android 下载
              </a>
              <a
                href="#features"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#features')?.scrollIntoView({ behavior: 'smooth' });
                }}
                className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-6 py-3 border-2 border-foreground-300 text-foreground-600 font-semibold text-sm rounded-md hover:border-primary-400 hover:text-primary-500 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-global-line text-lg"></i>
                轻量版入口
              </a>
            </div>
            <p className="text-xs text-foreground-500 mt-3">{appEntry.updateDate}</p>
          </div>

          <div className="shrink-0">
            <div className="w-48 h-48 md:w-56 md:h-56 bg-background-50 border-2 border-background-200 rounded-lg flex flex-col items-center justify-center gap-2 p-4">
              <div className="w-32 h-32 md:w-36 md:h-36 bg-foreground-800 rounded-md flex items-center justify-center">
                <span className="text-background-50 text-[10px] text-center leading-tight">{appEntry.qrLabel}</span>
              </div>
              <span className="text-xs text-foreground-500">{appEntry.qrLabel}</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}